import { Component, OnInit } from '@angular/core';
import { ApiPartnerService } from '../../api/api-partner.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
// import { FormControl} from '@angular/forms';
import { LoadJsService } from '../../load-js/load-js.service';
import {URLSearchParams} from '@angular/http';
import { AuthenticationService } from '../../_services/authentication.service';




@Component({
  selector: 'app-subpartnerliststb',
  templateUrl: './subpartnerliststb.component.html',
  styleUrls: ['./adminsubpartner.component.css']
})
export class SubpartnerliststbComponent implements OnInit {
 
  textSearch = new FormControl('');
  workorderList : any = {};
  DataList: any = {};
  ViewSTB: any = {};
  paging : any = {};
  Billingtype : any = [];
  Servicetype : any = [];
  msearch : string;
  statustype : string;
  typesearch : string;
  //paging_link : any = [];
  page_self = [];
  page_next = [];
  page_prev = [];
  meta = [];
  last_index : number;
  first_index : number;
  total_count : number;
  querySearch = false;
  searching = false;
  dataempty = true;
  currentParams = {};
  queryParams = '';
  searchQueryParams = '';
  href='';
  alert_act='';
  alert_actmsg='';

  isOne= false;
  alert_failed = false
  alert_success = false

  table_load = false
  table_data = false

  partnerid : number;
  subpartnerid : number;

  formAct = this.fb.group({
    // id: [''],
    // Login_name: [''],
    // UserID: [''],
    dropaction: [''],
    actiondate: [''],
    note: ['']
  })

  formRegister = this.fb.group({
    // id: [''],
    name: [''],
    alamat: [''],
    telp: [''],
    email: [''],
    //email2: [''],
    // servicetype: [''],
    // billingtype: [''],
    partnerid: [''],
    note: ['']
  })


  constructor(
    public partnerService: ApiPartnerService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    public LoadJsOrder: LoadJsService,
    private router: Router,
    private Auth: AuthenticationService,
  ) { }

  ngOnInit() {
    console.log(this.Auth.currentUserValue.partner);
    this.partnerid = this.Auth.currentUserValue.partner.partnerid;
    this.loadStart();
  }

  loadStart() {
    this.route.queryParams
      //.filter(params => params.order)
      .subscribe(params => {
        //console.log(params); // {order: "popular"}

        if (params.search != '' && params.search != undefined ){
          //console.log('search');
          //console.log(params.search);
         this.msearch = params.search; 
         this.statustype = params.statustype; 
         this.typesearch = params.typesearch; 
         this.querySearch = true;
        

         this.currentParams = params;
         this.queryParams = params.partner+'?'+this.queryStr(params);
        // this.loadSTB(this.queryParams);
         this.loadData(this.queryParams);
        
        }else{
          this.querySearch = false;
          this.currentParams = params;

          this.queryParams = params.partner+'?'+this.queryStr(params);
          //console.log(this.queryParams);
          //console.log(this.queryStr(params));
          /* pagination */
          //this.loadworkorder(this.currentParams);
          this.loadData(this.queryParams);
        }
      });
    //this.loadBillingtype();
    //this.loadServicetype();
  }

  refreshPage() {
    this.msearch = undefined 
    this.statustype = undefined
    this.typesearch = undefined 
    this.ngOnInit();
  }

  queryStr(options: any){
    let params = new URLSearchParams();
    for(let key in options){
        params.set(key, options[key]) 
    }
    return params.toString();
  }
 
  cname(item: any)
  {
    if ( item.pairingto == null || item.pairingto == 0 ){
      return '-';
    }else{
      return item.customer.nama;
    }
  }

  cstatus(item: any)
  {
    if ( item.customer == null || item.customer == 0 ){
      return '-';
    }else{
      return item.customer.customerstatusname;
    }
  }
  cstatusid(item: any)
  {
    if ( item.customer == null || item.customer == 0 ){
      return '-';
    }else{
      return item.customer.customersts;
    }
  }
  
  _services(item: any)
  {
    let service = '';
    if ( item.pairingto == null || item.pairingto == 0 ){
      return service;
    }else{
      item.services.forEach(function (value: any) {
        service += value.name + '\n';
      });

      return service.replace(/(\\r\\n)|([\r\n])/gmi, ', ');
    }
  }
  
  isPairing(item: any)
  {
    return (item.pairingto > 0 && item.pairingto != null);
  }

  isProvisioning(item)
  {
    return (item.provisioningsts == 1);
  }  
  
  isNotProvisioning(item)
  {
    return (item.provisioningsts == null || item.provisioningsts == 0);
  }  

  isSuspend(item)
  {
    return (item.provisioningsts == 2);
  }  
  
  copyMail() {
    // console.log(this.formRegister.value.email);
    this.formRegister.patchValue({
      email2: this.formRegister.value.email
    });
  }
  onActionclick(act:any, id: any)
  {
    this.alert_act = act;
    console.log(act);

    // console.log("suspend")
    // this.clearForm();
    // this.isOne = true;

    return this.partnerService.GetViewStb(id).subscribe((output: any) => {
      this.ViewSTB = output.data;
      console.log(output.data);


      // this.formAct = output.data;
      // const data = {
      //   'id' : this.ViewSTB.id,
      //   'Login_name' : this.ViewSTB.macaddress,
      //   'UserID' : this.ViewSTB.macaddress
      // }
      // this.formAct.setValue(data);
      // console.log(output.data);

    })
  }
    
  onActivation(item: any)
  {
    let data = this.formAct.value;
    
    data['id'] = this.ViewSTB.id;
    data['Login_name'] = this.ViewSTB.macaddress;
    data['UserID'] = this.ViewSTB.macaddress;

    console.log(data);

    return this.partnerService.PostSubscription(data).subscribe((output: any) => {
    // return this.partnerService.PostSubscription({UserID:item.macaddress, 'Login_name':item.macaddress, 'id':item.id}).subscribe((output: {}) => {
      console.log(output);
      if (output['status']){
        //this.loadSTB();
        // console.log(output);
        this.refreshPage();
        this.LoadJsOrder.loadScriptProductStb()
        // this.alert_actmsg = actmsg;
      }else{
        
        this.LoadJsOrder.loadScriptProductStb()
        // this.alert_actmsg = actmsg;
      }
    });
  }
  
  onReActivation(item: any)
  {
    let data = this.formAct.value;

    data['id'] = this.ViewSTB.id;
    data['Login_name'] = this.ViewSTB.macaddress;
    data['UserID'] = this.ViewSTB.macaddress;

    console.log(data);

    return this.partnerService.PostReconnect(data).subscribe((output: any) => {
    // return this.partnerService.PostReconnect({UserID:item.macaddress, 'Login_name':item.macaddress, 'id':item.id}).subscribe((output: {}) => {
      if (output['status']){
        //this.loadSTB();
        // console.log(output);
        this.refreshPage();
        this.LoadJsOrder.loadScriptProductStb()
        // this.alert_actmsg = actmsg;
      }else{
        
        this.LoadJsOrder.loadScriptProductStb()
        // this.alert_actmsg = actmsg;
      }
    });
  }

  onSuspend(item: any)
  {
    // console.log(item);
    // const datamaster = {
      //   'id' : this.ViewSTB.id,
      //   'Login_name' : this.ViewSTB.macaddress,
      //   'UserID' : this.ViewSTB.macaddress
      // }
      // data.push( datamaster );
    // this.alert_act = act;

    let data = this.formAct.value;

    data['id'] = this.ViewSTB.id;
    data['Login_name'] = this.ViewSTB.macaddress;
    data['UserID'] = this.ViewSTB.macaddress;

    console.log(data);

    return this.partnerService.PostSuspend(data).subscribe((output: any) => {
    // return this.partnerService.PostSuspend({UserID:item.macaddress, 'Login_name':item.macaddress, 'id':item.id}).subscribe((output: any) => {
      if (output['status']){
        //this.loadSTB();
        // console.log(output);
        this.refreshPage();
        this.LoadJsOrder.loadScriptProductStb()
        // this.alert_actmsg = actmsg;
      }else{
        
        this.LoadJsOrder.loadScriptProductStb()
        // this.alert_actmsg = actmsg;
      }
    });

  }

  onTermination(item: any)
  {
    let data = this.formAct.value;
    
    data['id'] = this.ViewSTB.id;
    data['Login_name'] = this.ViewSTB.macaddress;
    data['UserID'] = this.ViewSTB.macaddress;

    console.log(data);

    return this.partnerService.PostUnSubscription(data).subscribe((output: any) => {
    // return this.partnerService.PostUnSubscription({UserID:item.macaddress, 'Login_name':item.macaddress, 'id':item.id}).subscribe((output: any) => {
        if (output['status']){
          //this.loadSTB();
          this.refreshPage();
          this.LoadJsOrder.loadScriptProductStb()
          // this.alert_actmsg = actmsg;
        }else{
          this.LoadJsOrder.loadScriptProductStb()
          // this.alert_actmsg = actmsg;
        }
      });
  }

  onReconnect(item)
  {
    if (!confirm('Yakin Reconnect?'))
    {
      return;
    }

    return this.partnerService.PostReconnect({UserID:item.macaddress, 'Login_name':item.macaddress, 'id':item.id}).subscribe((output: {}) => {
        if (output['status']){
          //this.loadSTB();
        }else{
          alert(output['msg']);
        }
      });
  
  }

  onSetcust(id: any) {

    //this.loadCustomer(id);
  }

  submitAddSubPartner(item: any) {
    
    this.formRegister.patchValue({
      partnerid: this.partnerid
    });

    let data = this.formRegister.value;

    console.log(data);
    return this.partnerService.PostAddSubpartner(data).subscribe((output: any) => {
      console.log(output);
      this.loadData('?');
    })
  }

  submitCustomer(item: any) {
    let data = this.formRegister.value;

    
    data.snstb = this.ViewSTB.sn;
    data.partnerid = this.ViewSTB.partnerid;
    return this.partnerService.PostCustomer(data).subscribe((output: any) => {
      console.log(output);

      if ( output.status ){
      	this.ngOnInit()
        this.LoadJsOrder.loadScriptProductStb()
        this.alert_success = true
        this.alert_failed = false

        setTimeout(()=>{
          this.redirectSetlayanan("customers/services/"+output.data.customer.id);
        }, 3000);
        
      } else {
      	this.LoadJsOrder.loadScriptProductStb()
        this.alert_success = false
        this.alert_failed = true
      }

    })
  }

  loadCustomer(id: any) {
    return this.partnerService.GetViewStb(id).subscribe((output: any) => {
    console.log(output);
     	this.ViewSTB = output.data;
    })
  }

  // Issues list
  loadData(params: any) {
    this.table_data = false
    this.table_load = true
    return this.partnerService.GetStbSubpartner(params).subscribe((output: any) => {
    console.log(output);
      this.DataList = output.data;

      this.table_load = false
      this.table_data = true

      this.paging = output.pagex;
      this.page_self = output.pagex.self;
      this.page_next = output.pagex.next;
      this.page_prev = output.pagex.prev;
      this.meta = output.meta;
      this.total_count = this.meta['totalCount'];
      let self = this.page_self['page'];
      if ( self * this.meta['perPage'] < this.meta['totalCount']){
        this.last_index = (self * this.meta['perPage']);
      }else{
        this.last_index = this.meta['totalCount'];
      }
      
      this.first_index = ((self-1)*this.meta['perPage'])+1;

      // console.log(this.paging);
      //this.paging_link = this.DataList.paging.links;
    })
  }

  loadBillingtype()
  {
    return this.partnerService.GetBillingtype().subscribe((output: any) => {
      console.log(output);
      this.Billingtype = output.data;
    })
  }

  loadServicetype()
  {
    return this.partnerService.GetProductsource().subscribe((output: any) => {
      console.log(output);
      this.Servicetype = output.data;
    })
  }
  
  clearForm() {
    this.formRegister.reset();
    this.formAct.reset();
  }

  search()
  {
    if ( this.msearch == undefined){
      this.msearch = '';
    }

    this.querySearch = true;
    if ( this.typesearch == undefined ){
      this.searchQueryParams = '?page='+this.page_self['page']+'&search='+this.msearch;
    }else{
      this.searchQueryParams = '?page='+this.page_self['page']+'&search='+this.msearch+'&typesearch='+this.typesearch;
    }
    
    if ( this.statustype != undefined ){
      this.searchQueryParams += '&statustype='+this.statustype;
    }
    this.loadData(this.searchQueryParams);
  }

  redirectSetlayanan(params: any) {
    this.router.navigate([params]);
  }

  queryStrSearch()
  {
    if ( this.msearch ){
      return '&search='+this.msearch;
    }else{
      return '';
    }
  }
  
}

